export enum EnumTongHaoStatus {
  Follow = '0',
  Discover = '1',
  InkLightUpLife = '2',
  GoodHomework = '3',
  StudyInsight = '4',
  BackToHoushan = '5',
  SnackTime = '6',
  XuantongGathering = '7',
  ClassmateGathering = '8',
  ClassmateWork = '9',
  FenTong = '10'
}
